import { IconButton, Tooltip } from '@mui/material'

import { useLocation } from 'react-router-dom'
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material'

export const REFER = 'refer'
export function IssueButton() {
  const { pathname } = useLocation()
  if (pathname.startsWith('/issues')) {
    return <></>
  }
  return (
    <Tooltip title="Create new issue in new window">
      <IconButton
        onClick={() =>
          window.open(
            `/issues/new?${REFER}=${encodeURIComponent(window.location.href)}`,
            '_blank'
          )
        }
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1300,
          opacity: 0.1,
          transition: 'opacity 0.2s',
          '&:hover': { opacity: 1 },
          bgcolor: 'background.paper',
          boxShadow: 2,
        }}
      >
        <HelpOutlineIcon />
      </IconButton>
    </Tooltip>
  )
}
